import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * メッセージアイコン（封筒から手紙が出ている）
 */
export const MessageOpenIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        {/* 開いたフタ（手紙の両脇に見える部分） */}
        {/* 手紙と重なる部分は描画しない */}
        <path
            d="M2 10l4-2.8M22 10l-4-2.8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* 手紙部分（元のサイズに戻す） */}
        <path
            d="M6 13V3h12v10"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        
        {/* 手紙のテキストライン */}
        <path
            d="M9 6h6M9 9h4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* 封筒本体（ポケット） */}
        <path
            d="M2 10l10 7 10-7v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
